import { create } from 'zustand';

export type InputSource = 'keyboard' | 'gamepad';

interface InputSourceState {
  /** Last device that produced an input. */
  lastSource: InputSource;
  setLastSource: (src: InputSource) => void;
}

/**
 * Updated by `InputService` on each keydown / button-down / axis-cross.
 * Consumed by UI hooks (keys shown in the HUD, interaction popups, etc.) that
 * adapt their keyboard/gamepad display.
 */
export const useInputSourceStore = create<InputSourceState>((set) => ({
  lastSource: 'keyboard',
  setLastSource: (src) =>
    set((state) => (state.lastSource === src ? state : { lastSource: src })),
}));
